<script setup>
    import { ref, onMounted, onUnmounted } from 'vue';

    import DialogListener from './Application/dialogListener.jsx';
    import StartApplication from './Application/startApplication.jsx';
    import ActionService from './Application/components/ActionService.jsx';

    import './JavaScript/totalcareicons/v1/totalcareicons.css';
    import './JavaScript/font-awesome/v4.7.0/css/care-font-awesome.min.css';
    import './Application/components/css/ToolTip.css';
    import ApiService from '@/Services/api';
    import TokenService from '@/Services/token';
    import WebSocketService from '@/Services/webSocketService';
    import CareService from '@/Services/careService';

    import { appSettings, careTokenSettings } from '@/Shared/appSettings';
    import { applyLocalDevWhiteLabel } from '@/Shared/localDevWhiteLabel';
    import theme from '@/plugins/theme';
    import PlantUML from '@/Services/plantUml';

    import EventCoordinator from '@/Services/serverEventCoordinator';
    import TokenEventListener from '@/Services/tokenEventListenerService.jsx';

    import localStorageSyncService from '@/Services/localStorageSyncService';
    //import Vue from 'vue';

    //import 'ag-grid-community/styles/ag-grid.css';
    import 'ag-grid-community/styles/ag-theme-alpine.css';

    import { ModuleRegistry } from "ag-grid-community";
    import { AllEnterpriseModule, LicenseManager, IntegratedChartsModule, ServerSideRowModelModule, SparklinesModule } from "ag-grid-enterprise";
    import { AgChartsEnterpriseModule } from "ag-charts-enterprise";

    ModuleRegistry.registerModules([
        AllEnterpriseModule,
        IntegratedChartsModule.with(AgChartsEnterpriseModule),
        ServerSideRowModelModule,
        SparklinesModule.with(AgChartsEnterpriseModule)
    ]);

  //LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-062258}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{CCPro_Solutions_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{CCPro}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{CCPro}_need_to_be_licensed___{CCPro}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{24_June_2025}____[v3]_[0102]_MTc1MDcxOTYwMDAwMA==84de721c7d6c62654098653b0a858f5e");
    LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-083224}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{CCPro_Solutions_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{CCPro}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{CCPro}_need_to_be_licensed___{CCPro}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{24_June_2026}____[v3]_[0102]_MTc4MjI1NTYwMDAwMA==4cb16f95f572958963cb0641098d73bf");

    const currentRoute = ref(window.location.hash);
    const queryString = ref(window.location.search);
    const pathname = ref(window.location.pathname);
    const show = ref(false);

    let lockResolver;

    onMounted(async () => {
        var vuePortalOrigin = window.location.origin;
        var kubernetesHosted = !!(window.__kubernetesHosted || (typeof tmpCareAppSettings !== 'undefined' && tmpCareAppSettings.KubernetesHosted));

        if (!kubernetesHosted && vuePortalOrigin.includes('localportal')) {
            // For a fully local band, use a DNS entry called localportal.localhost
            // The default is port 8080 which comes from the local node server, change to 80 to get the kestral web server instead
            vuePortalOrigin = 'http://localportal.localhost:80';
            //vuePortalOrigin = 'http://localportal.localhost:80';
        }
        else if (!kubernetesHosted && vuePortalOrigin.includes('localhost')) {
            //needed if you want to run mvc locally
            vuePortalOrigin = 'http://vueportal.localhost:5002';

            //used if you're not running mvc locally.  use the same domain as the white lable settings, but do portal not api.
            vuePortalOrigin = 'https://portal.callcorplab.com';
        }

        if (window?.careTokenSettings?.info?.access_token && window?.careTokenSettings?.info?.refresh_token)
            await loadJavaScriptWithAccessToken(`${vuePortalOrigin}/ConfigurationScripts/config.js?portal=vue3`,
                window?.careTokenSettings?.info?.access_token,
                window?.careTokenSettings?.info?.refresh_token)
        else
            await loadFile(`${vuePortalOrigin}/ConfigurationScripts/config.js?portal=vue3`, 'js');

        await loadFile(`${vuePortalOrigin}/ConfigurationScriptsImages/configimages.js?hash=${encodeURIComponent(tmpCareAppSettings.WhiteLabel.ImageHash)}`, 'js');

        kubernetesHosted = kubernetesHosted || !!tmpCareAppSettings.KubernetesHosted;

        // For local development only ------------------------------------ //
        if (!kubernetesHosted && window.location.hostname.includes('localportal')) {
            tmpCareAppSettings.WhiteLabel.ApiUrl = 'http://localportal.localhost:81';
            tmpCareAppSettings.WhiteLabel.ApiUrlBandTemplate = 'http://localportal.localhost:81';
        }
        else if (!kubernetesHosted && window.location.hostname.includes('localhost')) {
            tmpCareAppSettings.WhiteLabel.ApiUrl = 'https://api.callcorplab.com';
            tmpCareAppSettings.WhiteLabel.ApiUrlBandTemplate = 'https://api-{bandId}.callcorplab.com';


            //tmpCareAppSettings.WhiteLabel.ApiUrl = 'https://api.localhost';
            //tmpCareAppSettings.WhiteLabel.ApiUrlBandTemplate = 'https://api.localhost';

            if (window.location.search.includes('atlocalhost')) {
                tmpCareAppSettings.WhiteLabel.ApiUrl = 'http://api.localhost:5004';
                tmpCareAppSettings.WhiteLabel.ApiUrlBandTemplate = 'http://api.localhost:5004';
            }
            //tmpCareAppSettings.WhiteLabel.ApiUrl = 'http://api-dev1.gp1-dev1-app07:5004';
            //tmpCareAppSettings.WhiteLabel.ApiUrlBandTemplate = 'http://api-dev1.gp1-dev1-app07:5004';
            
            // Uncomment this to test white label changes locally.
            // applyLocalDevWhiteLabel(tmpCareAppSettings.WhiteLabel);
        }
        // --------------------------------------------------------------- //

        Object.assign(appSettings, tmpCareAppSettings);

        if (appSettings.WhiteLabel?.ColorVariables)
            theme.importWhiteLabelSettings(appSettings.WhiteLabel);

        if (appSettings.WhiteLabel?.Vue3Css) {
            /* Create style document */
            var css = document.createElement('style');

            if (css.styleSheet)
                css.styleSheet.cssText = appSettings.WhiteLabel?.Vue3Css;
            else
                css.appendChild(document.createTextNode(appSettings.WhiteLabel?.Vue3Css));

            /* Append style to the tag name */
            document.getElementsByTagName("head")[0].appendChild(css);
        }

        var instanceGuid = sessionStorage.getItem("InstanceGuid");
        if (instanceGuid)
            appSettings.InstanceGuid = instanceGuid;
        else {
            instanceGuid = appSettings.InstanceGuid || utils.generateUUID();
            TokenService.SessionStorageOrMemory(null, "InstanceGuid", instanceGuid);
            appSettings.InstanceGuid = instanceGuid;
        }

        document.addEventListener('click', function enableLock() {
            document.removeEventListener('click', enableLock, false);

            // The browser won't let a tab that has a lock go to sleep. So we'll request a lock that we never give up
            // and use it to also prevent tabs from sleeping. Here is the link to signalr's docs recommending this approach:
            // https://learn.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-9.0&tabs=visual-studio#bsleep
            if (navigator && navigator.locks && navigator.locks.request) {
                const promise = new Promise((res) => {
                    lockResolver = res;
                });

                navigator.locks.request(instanceGuid, { mode: "shared" }, () => {
                    return promise;
                });
            }
        }, false);

        Object.assign(careTokenSettings, tmpCareTokenSettings);

        await localStorageSyncService.initializeLocalStorageSync(appSettings.WhiteLabel.LoginUrl);

        show.value = true;
    });

    onUnmounted(() => {
        ApiService.destroyed();
        TokenService.destroyed();
        WebSocketService.destroyed();
        PlantUML.destroyed();
        EventCoordinator.destroyed();
        TokenEventListener.destroyed();
        if (lockResolver)
            lockResolver();
    });

    async function createServices() {
        ApiService.created();
        TokenService.created();

        await CareService.created();

        EventCoordinator.created();

        await WebSocketService.created();

        PlantUML.created();
        TokenEventListener.created();
    }
</script>

<template>
    <q-layout view="hHh lpR fFf" style="height:100%; overflow:hidden;" v-if="show">
        <dialog-listener></dialog-listener>
        <action-service></action-service>
        <start-application :route="currentRoute" :query="queryString" :path="pathname" @start-application-created="createServices"></start-application>
    </q-layout>
</template>

<style>
header {
  line-height: 1.5;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

#app {
    display: flex;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }
}

    pre {
        border: 1px solid #ccc;
        border-radius: 8px;
        margin-bottom: 1rem;
    }

    /* -- Override the default capitalization on tab labels -- */
    .q-tab {
        text-transform: none !important;
        font-weight: 500;
    }

    /* Sentence case for portal buttons (BasicButton + opt-in QBtn).
       Opt out per control with ControlData.UseLiteralCasing → class c-useLiteralCasing.
       Also defined in BasicButton.css for ControlDesigner (imports that stylesheet). */
    .c-BasicButton:not(.c-useLiteralCasing) .q-btn,
    .c-SentenceCaseButton:not(.c-useLiteralCasing) {
        text-transform: lowercase;
    }

    .c-BasicButton:not(.c-useLiteralCasing) .q-btn__content .translation-container:first-of-type > span:first-of-type::first-letter,
    .c-BasicButton:not(.c-useLiteralCasing) .q-btn__content > span:first-of-type::first-letter,
    .c-SentenceCaseButton:not(.c-useLiteralCasing) .q-btn__content .translation-container:first-of-type > span:first-of-type::first-letter,
    .c-SentenceCaseButton:not(.c-useLiteralCasing) .q-btn__content > span:first-of-type::first-letter {
        text-transform: uppercase;
    }

    .c-BasicButton.c-useLiteralCasing .q-btn,
    .c-SentenceCaseButton.c-useLiteralCasing,
    .c-useLiteralCasing.q-btn {
        text-transform: none;
    }

    /* Same sentence case for PopupMenuButton items (and SoftPhone menus). */
    .PopupMenuButtons .q-item__label {
        text-transform: lowercase;
    }

    .PopupMenuButtons .q-item__label::first-letter {
        text-transform: uppercase;
    }

    .c-PopupMenuButton.c-useLiteralCasing .PopupMenuButtons .q-item__label,
    .c-PopupMenuButton.c-useLiteralCasing .PopupMenuButtons .q-item__label::first-letter {
        text-transform: none;
    }

    /* Quasar $generic-border-radius is set to 8px in quasar-variables.sass. */
    .rounded-borders {
        border-radius: var(--cc-radius, 8px);
    }

    .c-BasicTab .q-tabs {
        margin-bottom: 16px;
    }
    
    .c-formTabs .q-tabs {
        margin-bottom: 0;
    }

    .c-BasicTab .q-tabs,
    .c-formTabs .q-tabs {
        border-bottom: 1px solid var(--v-lightGreyBorder-base);
        padding-bottom: 8px;
        padding-top: 16px;
    }


    .c-BasicTab .q-tab,
    .c-formTabs .q-tab {
        border-radius: 8px;
        /* Quasar's .q-tab sets min-height: 48px, which overrides height alone */
        min-height: 27px;
        height: 27px;
    }

    .c-BasicTab .q-tab__content,
    .c-formTabs .q-tab__content {
        min-height: 27px;
        padding: 0;
    }

    .c-BasicTab .q-tab--active,
    .c-formTabs .q-tab--active {
        color: var(--v-primary-base);
        background: var(--v-activeBackground-base);
    }

    .vertical-tabs-left .q-tab {
        justify-content: left;
    }

    .vertical-tabs-left .q-tab__content {
        justify-content: left;
    }

    /* DynamicMenuList: node row height, larger font, pointer cursor, no text selection */
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node {
        min-height: 0;
        width: 100%;
        margin: 0;
        padding-top: 0;
        padding-bottom: 0;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree {
        width: 100%;
        /* Clip the -100vw highlight to the menu width (not nested indent boxes). */
        overflow: hidden;
        padding: 0;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__children {
        width: 100%;
        /* Keep visible so nested row highlights can paint left past padding-left indent. */
        overflow: visible;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node-collapsible {
        /* Must stay visible — overflow:hidden here clips ::before at each expand level,
           so deep items' primary background stops short of the menu's left edge.
           QSlideTransition sets overflow-y during expand/collapse animations. */
        overflow: visible;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header {
        width: 100%;
        min-height: 0;
        padding-top: 0;
        padding-bottom: 0;
        padding-right: 0;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header:hover,
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header:hover .q-tree__node-header-content {
        background: transparent !important;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header .q-focus-helper {
        background: transparent !important;
        opacity: 0 !important;
    }
    /* Selected node: background highlight and prominent text (override default gray) */
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header-content {
        display: flex;
        flex: 1 1 0;
        min-width: 0;
        width: 100%;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .c-DynamicMenuList-node-header--selected {
        color: var(--v-primary-base);
        background-color: transparent;
    }
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-content {
        font-size: 1rem;
        flex: 1 1 0;
        min-width: 0;
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
    }
    .c-DynamicMenuList .c-DynamicMenuList-node-header {
        cursor: pointer;
        user-select: none;
        font-size: 1rem;
        position: relative;
        z-index: 0;
    }
    .c-DynamicMenuList .c-DynamicMenuList-node-header::before {
        content: '';
        position: absolute;
        /* Keep flush with the row — top/bottom -1px made the highlight bleed into neighbors. */
        inset: 0;
        left: -100vw;
        background-color: color-mix(in srgb, var(--v-primary-base) 12%, transparent);
        pointer-events: none;
        z-index: -1;
        opacity: 0;
        transition: opacity .12s ease-in-out;
    }
    /* Hover shade for all rows; selected keeps shade. No focus-within — parents must not stick after click. */
    .c-DynamicMenuList .c-DynamicMenuList-tree .q-tree__node .q-tree__node-header:hover .c-DynamicMenuList-node-header::before,
    .c-DynamicMenuList .c-DynamicMenuList-node-header--selected::before {
        opacity: 1;
    }
    .c-DynamicMenuList .c-DynamicMenuList-node-header--selected::before {
        border-right: 3px solid var(--v-primary-base);
    }
    /* Parent debug info: invisible hit zone on the right edge; icon only while pointer is over it. */
    .c-DynamicMenuList .c-DynamicMenuList-node-edge {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        z-index: 1;
    }
    .c-DynamicMenuList .c-DynamicMenuList-node-edge:hover {
        opacity: 1;
    }

    /* USER DEFINED AREAS */
    .mainBodyAlertNotification {
        position: absolute;
        right: -100%;
        top: 72px;
        min-width: 333px;
        min-height: 60px;
        border-radius: 8px;
        transition: all 1s, transform 1s;
    }

        .mainBodyAlertNotification.notify {
            right: 20px;
            transition: all 1s, transform 1s;
        }

    .debug-refresh-icon,
    .debug-form-icon {
        /* White + difference ≈ inverse of whatever is painted behind the glyph. */
        color: #fff;
        mix-blend-mode: difference;
        /* Helps on mid-tone backgrounds where difference alone can land near gray. */
        filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.85));
    }

    .debug-refresh-icon {
        position: absolute;
        /*top: 0;
        left: 0;*/
        z-index: 2;
        font-size: medium;
    }

    .debug-form-icon {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
    }

    .nav-selected-item {
        /*color: white;*/
        background-color: var(--v-lightBlueBackground-base);
    }

    div.bordered-list-item div.q-item {
        border: 1px solid var(--q-lightGreyBorder, #6E6E82) !important;
    }

        div.bordered-list-item div.q-item .q-item__label {
            font-size: 14px;
            font-weight: 400;
        }

    /* Constrain QInput/QSelect height to 28px edge-to-edge in property grids */
    .property-grid .q-field {
        font-size: 14px !important;
        padding: 0;
        min-height: 0;
        max-height: 28px;
        background-color: white;
    }

    .property-grid .q-field .q-field__control {
        height: 28px;
        min-height: 28px;
        max-height: 28px;
        display: flex;
        align-items: center;
    }

    .property-grid .q-field .q-field__marginal {
        align-self: center;
    }

    .property-grid .q-field .q-field__control .q-field__native,
    .property-grid .q-field .q-field__control-container {
        height: 26px;
        padding-top: 1px;
        padding-bottom: 1px;
        min-height: 0;
    }

    /* PropertyGrid (Phase A1): value column + Quasar QField flex can shrink in narrow panels (flex min-width:auto default) */
    .c-PropertyGrid td.property-grid {
        min-width: 0;
        max-width: 100%;
    }

    .c-PropertyGrid td.property-grid .q-field {
        min-width: 0;
        max-width: 100%;
    }

    .c-PropertyGrid td.property-grid .q-field__inner,
    .c-PropertyGrid td.property-grid .q-field__control,
    .c-PropertyGrid td.property-grid .q-field__control-container {
        min-width: 0;
        max-width: 100%;
    }

    .c-PropertyGrid td.property-grid .q-field__inner {
        width: 100%;
    }

    /* PropertyGrid: QSelect use-input — shrink div.q-field__native.row vs flex min-width:auto */
    .c-PropertyGrid td.property-grid .q-select .q-field__native.row {
        min-width: 0 !important;
        max-width: 100%;
        overflow: hidden;
    }

    .c-PropertyGrid td.property-grid .q-select .q-field__input {
        min-width: 0 !important;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* PropertyGrid (Phase A2): limit label column on top-level rows only (avoid nested tables inside cells) */
    table.c-PropertyGrid > tbody > tr > td:first-child:not([colspan]) {
        max-width: 45%;
        overflow: hidden;
        vertical-align: top;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    table.c-PropertyGrid > tbody > tr > td:first-child:not([colspan]) > span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /*
     * PropertyGrid2: same scroll contract as PropertyGrid v1 `<table>` — hosts (VerticalStack, BasicForm,
     * ControlDesigner, FlowV2) provide vertical scroll; the grid never establishes overflow-y:auto here.
     */
    .c-PropertyGrid2 {
        overflow-x: hidden;
        overflow-y: visible;
        min-height: auto;
    }

    /*
     * Nested PropertyGrid2 (expandable object / Options / inject pg2Nested): do not shrink in flex parents or
     * create an inner scrollbar — same visual as v1 nested `<table>` rows.
     */
    .c-PropertyGrid2.c-PropertyGrid2--nested {
        min-height: auto !important;
        overflow-y: visible !important;
    }

    /*
     * Read-only mode (e.g. Control Designer JSON tab): same overlay pattern as design-time components —
     * intercept pointer events so underlying Quasar fields and schema editors cannot receive focus or edits.
     */
    .c-PropertyGrid2.c-PropertyGrid2--readonly {
        position: relative;
    }

    .c-PropertyGrid2.c-PropertyGrid2--readonly > .c-PropertyGrid2__readonlyOverlay {
        z-index: 50;
        cursor: not-allowed;
        pointer-events: auto;
        opacity: 0.12;
        border-color: transparent;
        background: rgba(0, 0, 0, 0.12);
    }

    .c-PropertyGrid2.c-PropertyGrid2--readonly > .c-PropertyGrid2__readonlyOverlay:hover {
        opacity: 0.18;
    }

    /*
     * Control Designer properties dock panel: full-viewport click blocker while JSON tab is active.
     * Sits above the scroll container so clicks cannot reach fields below.
     */
    .control-designer-property-grid-blocker {
        position: absolute;
        inset: 0;
        z-index: 10000;
        cursor: not-allowed;
        pointer-events: auto;
        opacity: 0.12;
        border-color: transparent;
        background: rgba(0, 0, 0, 0.12);
    }

    .control-designer-property-grid-blocker:hover {
        opacity: 0.18;
    }

    /* Row stack (tbody-like): hosts scroll — never overflow-y:auto (same as v1 PropertyGrid). */
    .c-PropertyGrid2__scroll {
        flex: none;
        min-width: 0;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    /*
     * PropertyGrid2 under vue3-smooth-dnd (Form2Array reorder): neutral inner wrapper so drag layout stays bounded.
     */
    .smooth-dnd-container .c-PropertyGrid2 {
        height: auto !important;
        max-height: none;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .smooth-dnd-container .c-PropertyGrid2 > .c-PropertyGrid2__scroll {
        flex: none !important;
        overflow-y: hidden !important;
        overflow-x: hidden;
    }

    .c-PropertyGrid2__breadcrumb {
        min-width: 0;
        overflow-x: hidden;
    }

    .c-PropertyGrid2__row {
        display: grid;
        grid-template-columns: minmax(0, var(--pg2-label, 50%)) 6px minmax(0, 1fr);
        /* stretch so the empty gutter column gets full row height (align-items:start collapses it to 0) */
        align-items: stretch;
        min-width: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.055);
    }

    /* Pg2Row outside PropertyGrid2 / Form2Array subtree: two columns, no gutter strip */
    .c-PropertyGrid2__row--noSplit {
        display: grid;
        grid-template-columns: minmax(0, var(--pg2-label, 50%)) minmax(0, 1fr);
        align-items: stretch;
        min-width: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.055);
    }

    /* Primitive array item: [i] + editor + toolbar on one line */
    .c-PropertyGrid2__arrayItemRow {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        gap: 6px;
        min-width: 0;
        width: 100%;
        box-sizing: border-box;
    }

    .c-PropertyGrid2__arrayItemRow__grow {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid silver;
        border-bottom-style: dotted;
    }

    .c-PropertyGrid2__arrayItemRow__subtitle {
        font-size: 12px;
        color: #555;
        margin-top: 2px;
        margin-bottom: 4px;
        padding-left: 22px;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* Inline label|control inside array item (wrapPropertyGridRow) */
    .c-PropertyGrid2__arrayItemRow--field {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
        min-width: 0;
        flex: 1 1 auto;
    }

    .c-PropertyGrid2__arrayItemRow__label {
        flex: 0 0 auto;
        min-width: 0;
        max-width: 42%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .c-PropertyGrid2__arrayItemRow__control {
        flex: 1 1 auto;
        min-width: 0;
    }

    .c-PropertyGrid2__label {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        align-self: start;
        /* faint vertical rule between label column and splitter */
        border-right: 1px solid rgba(0, 0, 0, 0.06);
        padding-right: 6px;
        box-sizing: border-box;
    }

    .c-PropertyGrid2__labelInner {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .c-PropertyGrid2__gutter {
        cursor: col-resize;
        touch-action: none;
        user-select: none;
        position: relative;
        z-index: 2;
        min-height: 28px;
        box-sizing: border-box;
        /* subtle visible splitter track */
        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.04) 0%,
            rgba(0, 0, 0, 0.09) 50%,
            rgba(0, 0, 0, 0.04) 100%
        );
        box-shadow:
            inset 1px 0 0 rgba(255, 255, 255, 0.55),
            inset -1px 0 0 rgba(0, 0, 0, 0.06);
        border-radius: 2px;
    }

    /* Ace / JSON editors: no box border; light fill so the block is still visible */
    .c-PropertyGrid2__editorHost {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        box-sizing: border-box;
    }

    .c-PropertyGrid2__mutedBox {
        background: rgba(0, 0, 0, 0.025);
        border-radius: 2px;
        padding: 4px 6px;
        box-sizing: border-box;
    }

    .c-PropertyGrid2__textareaFlat {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        border: none;
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        padding: 6px;
        font-family: monospace;
        font-size: 12px;
        resize: vertical;
    }

    /* SchemaProperties nested table: row lines only (no outer chrome) */
    .c-PropertyGrid2__schemaRow {
        border-bottom: 1px solid rgba(0, 0, 0, 0.055);
        padding-bottom: 4px;
        margin-bottom: 2px;
    }

    .c-PropertyGrid2__schemaTable {
        border: none;
    }

    /* SchemaProperties: same label|gutter|value ratio as PropertyGrid2 rows (--schema-label-pct on .c-SchemaProperties__splitRoot) */
    .c-SchemaProperties__splitRoot {
        min-width: 0;
    }

    .c-SchemaProperties__schemaRow,
    .c-SchemaProperties__schemaHeaderRow {
        display: grid;
        grid-template-columns: minmax(0, var(--schema-label-pct, 50%)) 6px minmax(0, 1fr) auto;
        /* Zero gap so the type column can sit flush against the splitter; spacing moved to cells below. */
        column-gap: 0;
        row-gap: 0;
        align-items: stretch;
        min-width: 0;
    }

    /* Former column-gap before gutter: keep space between name and splitter */
    .c-SchemaProperties__schemaRow .c-SchemaProperties__nameCell {
        padding-right: 10px;
        box-sizing: border-box;
    }

    .c-SchemaProperties__schemaHeaderRow > div:first-child {
        padding-right: 10px;
        box-sizing: border-box;
    }

    /* Former column-gap after type column: keep space before actions */
    .c-SchemaProperties__schemaRow .c-SchemaProperties__actionsCell {
        margin-left: 10px;
    }

    /* Override global schema row spacing so the gutter reads as one continuous strip */
    .c-SchemaProperties__schemaRow.c-PropertyGrid2__schemaRow {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    }

    .c-SchemaProperties__nameCell {
        min-width: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: 2px 0;
        box-sizing: border-box;
    }

    /* Name column: inner row fills grid track (default flex item would size to content only). */
    .c-SchemaProperties__nameCell > .property-grid {
        flex: 1 1 auto;
        min-width: 0;
        width: 100%;
    }

    /* Same Quasar width chain as .c-PropertyGrid2__value so QInput fills the name cell. */
    .c-SchemaProperties__nameCell .q-field {
        min-width: 0;
        max-width: 100%;
    }

    .c-SchemaProperties__nameCell .q-field__inner,
    .c-SchemaProperties__nameCell .q-field__control,
    .c-SchemaProperties__nameCell .q-field__control-container {
        min-width: 0;
        max-width: 100%;
    }

    .c-SchemaProperties__nameCell .q-field__inner {
        width: 100%;
    }

    .c-SchemaProperties__nameCell .q-field__native {
        min-width: 0 !important;
        max-width: 100%;
        width: 100%;
        box-sizing: border-box;
    }

    .c-SchemaProperties__typeCell {
        min-width: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
    }

    /*
     * SchemaProperties type column: fill the grid row and flush the QSelect to top/left/bottom.
     * Overrides .c-PropertyGrid2__value { align-self: start } and fixed 28px .q-field heights that
     * leave white space under a short control when the name column is taller.
     * Prefixed with .c-PropertyGrid2 so these beat later .c-PropertyGrid2 .property-grid .q-field rules.
     */
    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell.c-PropertyGrid2__value {
        align-self: stretch;
        align-items: stretch;
        padding: 0;
    }

    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell .q-field {
        flex: 1 1 auto;
        align-self: stretch;
        width: 100%;
        min-width: 0;
        min-height: 0;
        max-height: none;
        height: auto;
        padding-left: 0;
        padding-right: 0;
    }

    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell .q-field .q-field__inner {
        min-height: 0;
        height: 100%;
        padding-left: 0;
    }

    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell .q-field .q-field__control {
        height: 100%;
        min-height: 0;
        max-height: none;
        padding-left: 0;
    }

    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell .q-field .q-field__control-container {
        height: 100%;
        min-height: 0;
        display: flex;
        align-items: center;
    }

    .c-PropertyGrid2 .c-SchemaProperties__schemaRow .c-SchemaProperties__typeCell .q-field .q-field__control .q-field__native {
        height: 100%;
        min-height: 0;
        display: flex;
        align-items: center;
    }

    /* Property type QSelect: clear focus affordance (borderless fields hide default chrome) */
    .c-PropertyGrid2 .c-SchemaProperties__typeCell:focus-within {
        border-radius: 2px;
    }

    .c-PropertyGrid2 .c-SchemaProperties__typeCell:focus-within .q-field.q-field--focused .q-field__control {
        background: rgba(0, 0, 0, 0.04);
    }

    .c-PropertyGrid2 .c-SchemaProperties__typeCell .q-field.q-field--focused .q-field__control {
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.16);
        border-radius: 2px;
    }

    .c-SchemaProperties__actionsCell {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 0;
        align-self: center;
    }

    /* Full row-height splitter: no rounded corners, stretch with row (no extra bar from __label border-right) */
    .c-SchemaProperties__schemaRow .c-SchemaProperties__gutter {
        border-radius: 0;
        align-self: stretch;
        min-height: unset;
        width: 6px;
        min-width: 6px;
        padding: 0;
        box-sizing: border-box;
    }

    .c-SchemaProperties__gutterSpacer {
        width: 6px;
        min-width: 6px;
        align-self: stretch;
        box-sizing: border-box;
    }

    .c-SchemaProperties__schemaHeaderRow {
        font-weight: bold;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 6px;
        margin-bottom: 0;
        align-items: end;
    }

    .smooth-dnd-container .c-SchemaProperties__splitRoot {
        min-width: 0;
        overflow-x: hidden;
    }

    /* form2 nullable type: nested PropertyGrid2 reads as child panel (independent splitter is intentional) */
    .c-PropertyGrid2 .c-NullableType__nestedGrid {
        padding-left: 16px;
        margin-top: 2px;
        border-left: 1px solid rgba(0, 0, 0, 0.08);
        background: rgba(0, 0, 0, 0.02);
        border-radius: 2px;
        min-width: 0;
        box-sizing: border-box;
    }

    /* Quasar borderless: strip default outline pseudo */
    .c-PropertyGrid2 .q-field--borderless .q-field__control:before,
    .c-PropertyGrid2 .q-field--borderless .q-field__control:after {
        border: none !important;
    }

    .c-PropertyGrid2__fullRow {
        width: 100%;
        min-width: 0;
        overflow: hidden;
        border-bottom: 1px solid rgba(0, 0, 0, 0.045);
    }

    .c-PropertyGrid2__value {
        min-width: 0;
        max-width: 100%;
        align-self: start;
    }

    .c-PropertyGrid2__value .q-field {
        min-width: 0;
        max-width: 100%;
    }

    .c-PropertyGrid2__value .q-field__inner,
    .c-PropertyGrid2__value .q-field__control,
    .c-PropertyGrid2__value .q-field__control-container {
        min-width: 0;
        max-width: 100%;
    }

    .c-PropertyGrid2__value .q-field__inner {
        width: 100%;
    }

    .c-PropertyGrid2__value .q-select .q-field__native.row {
        min-width: 0 !important;
        max-width: 100%;
        overflow: hidden;
    }

    .c-PropertyGrid2__value .q-select .q-field__input {
        min-width: 0 !important;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .c-PropertyGrid2 .property-grid .q-field {
        font-size: 14px !important;
        padding: 0;
        min-height: 0;
        max-height: 28px;
        background-color: white;
    }

    .c-PropertyGrid2 .property-grid .q-field .q-field__control {
        height: 28px;
        min-height: 28px;
        max-height: 28px;
        display: flex;
        align-items: center;
        background-color: white;
    }

    .c-PropertyGrid2 .property-grid .q-field .q-field__marginal {
        align-self: center;
    }

    .c-PropertyGrid2 .property-grid .q-field .q-field__control .q-field__native,
    .c-PropertyGrid2 .property-grid .q-field .q-field__control-container {
        height: 26px;
        padding-top: 1px;
        padding-bottom: 1px;
        min-height: 0;
    }

    .treeview-node {
        cursor: default;
        white-space: nowrap;
    }

        .treeview-node.selected {
            font-weight: bold;
        }

        .treeview-node.hastype {
            color: black;
        }

        .treeview-node.hasnotype {
            color: gray;
        }

        .treeview-node.highlight {
            color: red;
        }

        .treeview-node.permissions {
            color: darkorange;
        }

    .treeview-expand-collapse {
        cursor: pointer;
        font-size: 12px;
    }

    /* Vertical fill with scrolling in tab panels (Quasar q-panel) */
    .q-panel {
        display: flex;
        flex-direction: column;
        height: inherit;
        position: relative;
        flex-grow: 1;
        /*overflow: hidden;*/
         overflow: auto; 
    }
    .q-tab-panel {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .q-tab-panels {
        background: var(--v-pageBackground-base);
    }

    .q-tab-panels .q-panel {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
    }

    .c-sform-card-layout {
        padding: 0;
    }

    /* Schema form tabs: avoid phantom vertical scrollbar when content fits (flex min-height: auto vs height chain). */
    .c-formTabs .q-tab-panels {
        min-height: 0;
    }
    .c-formTabs .q-tab-panels .q-panel {
        min-height: 0;
    }
    .c-formTabs .q-tab-panel {
        min-height: 0;
    }
    /* Buffer below tab content when fields have hint bottom-slots. Multiline hints grow on focus;
       collapsing on blur can briefly overflow the scroll area (~one extra hint line).
       !important: formTabs sets inline padding shorthand (`32px 0 0`) which otherwise zeros bottom. */
    .c-formTabs .q-tab-panel:has(.q-field--with-bottom),
    .c-BasicTab .q-tab-panel:has(.q-field--with-bottom) {
        padding-bottom: 40px !important;
    }
    /* Override Quasar's .q-field__bottom: keep left (12px), remove bottom; full shorthand wins over later rule */
    .q-field__bottom {
        padding: 0 12px;
        position: relative !important;
        transform: none !important; 
        min-height: 20px; 
    }
    .q-field--with-bottom {
        padding-bottom: 0 !important;
    }
    .q-field__messages {
        align-items: flex-start; /*CHANGED By CallCorp - was flex-end */
        display: flex;
        font-size: 0.75rem;
        font-weight: 400;
        grid-area: messages;
        letter-spacing: 0.0333333333em;
        line-height: normal;
        min-height: 22px;
        padding-top: 3px; /*CHANGED By CallCorp - was 6px */
        justify-content: space-between;
        overflow-wrap: break-word;
        white-space: normal;
    }
    .q-tooltip {
        opacity: .85;
        max-width: 500px !important;
        font-size: 12px !important; /* was 14px; Quasar default 10px — CCDEV-17612 */
    }
    .q-tab-panels .q-panel {
        transition: none !important;
    }
    /* Opacity only — do not paint the whole field. Outlined controls are white
       (.q-field--outlined … .q-field__control); a root bg showed as a gray strip
       under the control in .q-field__bottom (e.g. SingleDatePicker with bottom-slots). */
    .q-field--disabled {
        opacity: 0.55;
    }

    /* Quasar readonly fields: mute the value text to signal non-editable state. */
    .q-field--readonly .q-field__native,
    .q-field--readonly .q-field__input,
    .q-field--readonly .q-field__prefix,
    .q-field--readonly .q-field__suffix {
        color: #6b7280;
    }

    /* Schemaform: white only on the control (input box). Border is drawn by __control:before on top of this; hint (__bottom) is a sibling so stays unchanged. */
    .sform-input-white .q-field__control {
        background-color: white;
    }

    /* Override auto-fill color for input fields */
    .sform-input-white .q-field__native:-webkit-autofill,
    .sform-input-white .q-field__native:-webkit-autofill:hover,
    .sform-input-white .q-field__native:-webkit-autofill:focus {
      -webkit-text-fill-color: inherit;
      -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
      box-shadow: 0 0 0 1000px #fff inset !important;
      transition: background-color 99999s ease-out;
    }

    /* Date range only: keep solid outline when readonly (picker still opens via menu).
       SingleDatePicker matches other schema readonly fields (Quasar dashed). */
    .sform-daterangepicker-input.q-field--readonly .q-field__control::before {
        border-style: solid;
    }

    /* Pointer only on the control chrome — not the hint/error bottom row.
       Covers SingleDatePicker, schema DateRangePicker, Calendar (CalendarPicker / reports),
       and native date/time inputs (schema date-time / date / time). */
    .sform-singledatepicker-input:not(.q-field--readonly) .q-field__control,
    .sform-daterangepicker-input:not(.q-field--readonly):not(.q-field--disabled) .q-field__control,
    .c-calendar-field:not(.q-field--readonly):not(.q-field--disabled) .q-field__control,
    .sform-nativedate-input:not(.q-field--readonly):not(.q-field--disabled) .q-field__control {
        cursor: pointer;
    }

    .dialog-size {
        min-height: 300px;
        min-width: 300px;
        transition: inherit !important;
    }

    /* Dialogs inherit $generic-border-radius (8px); keep explicit for nested shells. */
    .q-dialog__inner > div {
        border-radius: var(--cc-radius, 8px);
    }

    /* Firefox antialiases nested rounded corners separately, so the white card
       bleeds a hairline around the dark header's top curve. Paint the header
       1px past its box; the card's overflow clip trims the ring to the radius. */
    .q-dialog .q-toolbar.bg-navigation {
        box-shadow: 0 0 0 1px var(--v-navigation-base);
    }

    .dialog-resize {
        min-height: 300px;
        min-width: 300px;
        resize: both;
        transition: none !important;
    }

    /** override for card array background color styles */
    .card-array {
        border-radius: var(--cc-radius, 8px);
    }

    /** override for ag-grid to allow proper flex vertical sizing within a dialog (DP) **/
    .ag-grid-flex-layout { /*New class ADDED By CallCorp*/
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }
    .ag-root-wrapper { /* Existing ag-grid class */
        border: var(--ag-wrapper-border);
        border-radius: var(--ag-wrapper-border-radius);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
        flex-grow: 1; /*ADDED By CallCorp*/
    }

    /*
     * NativeVueHost pages — match VerticalStackContent HeaderControls chrome:
     *   style={{ padding: '2px 0', alignItems: 'center' }}
     * Do not put vertical q-gutter on the header row — q-gutter-sm’s negative
     * margin-top pulls actions above legacy HeaderControls.
     */
    .c-NativeVueHost-page {
        box-sizing: border-box;
    }

    .c-NativeVueHost-page__header {
        display: flex;
        flex-direction: row;
        flex-grow: 0;
        flex-shrink: 0;
        align-items: center;
        /* HeaderControls uses 2px all around; native still sat a few pixels
         * lower than other tabs, so top is pulled up with negative margin. */
        padding: 0 2px 2px 0;
        margin-top: -4px;
        /* Pull Quick Search up ~6px vs header + CcGrid chrome (8px) stacking. */
        margin-bottom: -6px;
        box-sizing: border-box;
    }

    /* main.css zeros last-child button q-mr-sm; restore here so KB / trailing
     * header actions keep chrome alignment with the grid below. */
    .c-NativeVueHost-page__header > :last-child {
        margin-right: 8px;
    }
    
    /*
     * AG Grid 34 draws the magnifying-glass via .ag-input-wrapper:before.
     * Theme padding (calc(spacing*1.5 + 12px)) is often overridden by portal input
     * rules, so Search... sits under the icon. Keep text to the right of the 12px glyph.
     */
    .ag-theme-alpine .ag-mini-filter .ag-input-field-input,
    .ag-theme-alpine .ag-filter-filter .ag-input-field-input,
    .ag-theme-alpine .ag-filter-add-select .ag-input-field-input,
    .ag-theme-alpine .ag-filter-toolpanel-search .ag-input-field-input {
        padding-left: 28px !important;
    }

    .center-aligned-cell{
        text-align: center;
    }

    .centerAligned .ag-header-cell-label {
        flex: 1;
        justify-content: center !important;
    }

    .rightAligned .ag-header-cell-label {
        flex: 1;
        justify-content: right !important;
        padding-right: 8px;
    }

    /** mdi spin and pulse animations */
    .mdi-animate-spin .q-icon {
        -webkit-animation: spin 2s infinite linear;
        animation: spin 2s infinite linear;
    }

    .mdi-animate-pulse {
        -webkit-animation: pulse 1s infinite steps(10);
        animation: pulse 1s infinite steps(10);
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @keyframes pulse {
        from {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }

    .left-align-text {
        justify-content: flex-start !important;
        text-align: left !important;
    }

    .resize-observer {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        border: none;
        background-color: transparent;
        pointer-events: none;
        display: block;
        overflow: hidden;
        opacity: 0;
    }

/*    .ProseMirror {
        flex-grow: 1;
        overflow: auto;
    }

    .ProseMirror-focused {
        outline: none;
        background-color: lightyellow;
    }

*/
    /* Transition styles for smooth animation */
    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: all 0.3s ease;
    }

    .slide-fade-enter-to,
    .slide-fade-leave-from {
        max-height: 100px; /* Adjust based on content height */
        opacity: 1;
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        max-height: 0;
        opacity: 0;
    }

    /******************* FORM DESIGNER STYLES ******************/
    .warning-blinking {
        animation: blinkingText 0.8s infinite;
    }

    @keyframes blinkingText {
        0% {
            color: yellow;
        }

        49% {
            color: red;
        }

        50% {
            color: red;
        }

        59% {
            color: red;
        }

        100% {
            color: yellow;
        }
    }

    .designer-container {
        /*padding: 3px;*/
        position: relative;
        z-index: 2; /* new - 10/27/2021 (working on Accordion) */
    }

    .designer-form {
        position: relative;
    }

    .designer-button {
        position: relative;
    }

    .designer-container-hovering {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.0;
        border: 2px solid;
        border-color: red;
        background: rgba(0,0,0,0.1);
        box-sizing: border-box;
        /*z-index: 1000;*/
        z-index: 2; /* was 1 - 10/27/2021 (working on Accordion) */
    }

    .designer-container-hovering__selected {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.0;
        border: 2px solid;
        border-color: red;
        background: rgba(0,0,0,0.1);
        box-sizing: border-box;
    }

    .designer-hsmstate {
        position: relative;
        z-index: 30;
    }

    .designer-hsmstate-hovering {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.0;
        border: 2px solid;
        border-color: mediumpurple;
        background: rgba(255,255,0,0.2);
        box-sizing: border-box;
        border-radius: 8px;
        z-index: 30;
    }

    .designer-user-control-hovering {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.0;
        border: 2px solid;
        border-color: red;
        background: rgba(255,65,65,0.2);
        box-sizing: border-box;
        z-index: 31;
    }

    .designer-container-selected-clickthrough {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        border: 2px solid;
        border-color: red;
        background: rgba(0,0,0,0.25);
        box-sizing: border-box;
        z-index: 30;
        pointer-events: none;
    }

    .designer-container-selected {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        border: 2px solid;
        border-color: red;
        background: rgba(0,0,0,0.25);
        box-sizing: border-box;
        pointer-events: none;
        z-index: 30;
    }

    .designer-container-selected-clickableitem {
        z-index: 35;
    }

    .c-FastGrid.designer-container.selected .ag-header-cell {
        cursor: pointer;
    }

    .c-FastGrid .ag-header-cell.fast-grid-dsgn-col-selected {
        box-shadow: inset 0 0 0 2px #1976d2;
    }

    .fast-grid-dsgn-action-cell {
        line-height: 1;
        padding: 1px 2px;
    }

    .fast-grid-dsgn-cmd-btn {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        border-radius: 8px;
        flex-shrink: 0;
    }

    .fast-grid-dsgn-cmd-btn--selected {
        box-shadow: inset 0 0 0 2px #1976d2;
    }

    .c-FastGrid .ag-cell.fast-grid-dsgn-action-col-cell {
        padding-left: 6px;
        padding-right: 4px;
    }

    .q-btn {
        font-weight: 400;
    }

    .fast-grid-dsgn-cmd-btn .q-btn {
        pointer-events: none;
    }

    .q-btn--rectangle {
        border-radius: var(--cc-radius-button, 8px);
    }

    .designer-hsm-selected {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        border: 2px solid;
        border-color: red;
        background: rgba(255,255,255,0.25);
        box-sizing: border-box;
        pointer-events: none;
        z-index: 31;
    }

    .designer-hsmstate-selected {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        border: 2px solid;
        border-color: mediumpurple;
        background: rgba(255,255,0,0.2);
        box-sizing: border-box;
        border-radius: 8px;
        pointer-events: none;
        z-index: 31;
    }

    .designer-user-control-selected {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        border: 2px solid;
        border-color: red;
        background: rgba(255,65,65,0.3);
        box-sizing: border-box;
        z-index: 31;
    }

    .designer-container-hovering:hover {
        opacity: 0.5;
    }

    .designer-user-control-hovering:hover {
        opacity: 0.5;
    }

    .designer-hsmstate-hovering:hover {
        opacity: 0.5;
    }

    .design-options {
        position: absolute;
        opacity: 0.5;
        color: blueviolet;
        font-size: smaller;
        cursor: pointer;
        z-index: 32;
    }

        .design-options:hover {
            text-decoration: underline;
        }

    .design-clickable {
        position: relative; /* absolute;*/
        cursor: pointer;
        z-index: 5;
    }

        .design-clickable:hover {
            text-decoration: underline;
        }

    /* ForEach designer: selectable ContentDef preview regions */
    .for-each-contentdef-dsgn {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 8px;
        min-width: 0;
    }

    .for-each-contentdef-dsgn--active {
        cursor: pointer;
    }

    .for-each-contentdef-dsgn--active:hover {
        outline: 1px dashed rgba(25, 118, 210, 0.45);
        outline-offset: 2px;
    }

    .for-each-contentdef-dsgn--selected {
        outline: 2px solid #1976d2;
        outline-offset: 2px;
    }

    .fieldpicker-table {
        width: 100%;
        background-color: #f0f0f0; /* Table background color */
        border: 1px solid #333; /* Border color */
        border-spacing: 2px;
        padding: 10px; /* Padding around the table content */
    }

        .fieldpicker-table th,
        .fieldpicker-table td {
            padding: 5px; /* Padding inside table cells */
            color: #333; /* Text color */
            vertical-align: top;
        }

        .fieldpicker-table th {
            background-color: #4CAF50; /* Header background color */
            color: white; /* Header text color */
        }

        .fieldpicker-table tr:nth-child(even) {
            background-color: #f2f2f2; /* Light gray for even rows */
        }

        .fieldpicker-table tr:nth-child(odd) {
            background-color: #ffffff; /* White for odd rows */
        }

    /***********************************************************/

    .joint-element.selected .joint-type-standard-rectangle-body {
        stroke: blue;
        stroke-width: 2;
        fill: lightblue;
    }

    /************* AG-Grid folder browser in FlowV2 ************/

    .ag-theme-alpine {
        --ag-header-background-color: var(--v-gridHeader-base);
        --ag-odd-row-background-color: var(--v-gridOddRow-base);
        --ag-border-color: var(--v-lightGreyBorder-base);
        --ag-secondary-border-color: var(--v-lightGreyBorder-base);
        /* Active filter accent — overridden in the scss block with $primary. */
        --ag-alpine-active-color: var(--v-primary-base);
        --ag-checkbox-checked-color: var(--v-primary-base);
        --ag-checkbox-indeterminate-color: var(--v-primary-base);
        --ag-selected-row-background-color: var(--v-activeBackground-base);
        --ag-row-hover-color: color-mix(in srgb, var(--v-primary-base) 12%, transparent);
        /* Used by .ag-root-wrapper (were previously undefined → invalid border). */
        --ag-wrapper-border: 1px solid var(--v-lightGreyBorder-base);
        --ag-wrapper-border-radius: 8px;
    }

    .ag-theme-alpine .ag-set-filter-list .ag-set-filter-item:has(.ag-checked),
    .ag-theme-alpine .ag-filter-list-panel .ag-set-filter-item:has(.ag-checked) {
        background-color: var(--v-activeBackground-base, #eef0ff);
    }

    /* Checked AG checkboxes (set filters / row selection) → new primary indigo. */
    .ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked,
    .ag-theme-alpine .ag-checkbox-input-wrapper.ag-indeterminate {
        --ag-checkbox-background-color: var(--v-primary-base, #4F46E5);
        --ag-checkbox-checked-color: #fff;
        background-color: var(--v-primary-base, #4F46E5);
        border-color: var(--v-primary-base, #4F46E5);
    }

    /* QCheckbox selected state → primary indigo (existing issue called out in design review). */
    .q-checkbox__inner--truthy {
        color: var(--v-primary-base, #4F46E5) !important;
    }

    .q-icon.mdi-checkbox-marked,
    .mdi.mdi-checkbox-marked,
    .q-icon.mdi-checkbox-marked-outline,
    .mdi.mdi-checkbox-marked-outline,
    .q-icon.mdi-checkbox-intermediate,
    .mdi.mdi-checkbox-intermediate {
        color: var(--v-primary-base, #4F46E5);
    }

    .ag-grid-noborder .ag-theme-alpine,
    .ag-grid-noborder .ag-root-wrapper {
        border: none !important;
        border-radius: 0 !important;
    }

    .ag-grid-noborder .ag-row {
        border: none !important;
    }

    /* Flat rows (no zebra): odd-row color matches main background — same as folder browser in FlowV2 */
    .ag-grid-noborder .ag-theme-alpine,
    .ag-grid-noborder .ag-theme-alpine-dark,
    .ag-grid-noborder .ag-theme-alpine-auto-dark {
        --ag-odd-row-background-color: var(--ag-background-color);
    }

    .ag-grid-noborder .ag-cell {
        border-right: none !important;
        border-left: none !important;
    }

    /* Remove blueish focus border on selected cell */
    .ag-grid-noborder .ag-cell-focus,
    .ag-grid-noborder .ag-cell:focus {
        border: none !important;
        outline: none !important;
        padding-top: 1px !important; /* Reset any focus-specific padding */
    }

    .ag-cell-wrapper {
        height: 100%;
    }

    /* ACE editor breakpoints for FlowV2 */
    .ace_gutter-cell.ace_breakpoint {
        border-radius: 15px;
        box-shadow: 0 0 1px 1px #8c2446 inset; /* Green glow; change color as needed */
        background-color: rgba(220, 16, 20, 0.75); /* Optional background */
    }

    /* Style for the execution marker in the gutter */
    .ace_gutter-cell.ace_execution-point::before {
        content: "▶"; /* Use a play button character */
        font-size: 13px;
        line-height: 10px;
        color: yellow;
        background-color: #ccc;
        border-radius: 50%;
        display: block;
        padding: 2px;
        margin: 0;
        position: absolute;
        top: 50%;
        left: 20%;
        transform: translate(-50%, -50%);
    }

    /* Optional: Highlight the entire line where execution is paused */
    .ace_active-line.ace_execution-line {
        background-color: #3b82f633; /* Light blue background highlight */
    }

    /* Current execution column (text-layer marker; distinct from red breakpoint column) */
    .ace_marker-layer .ace_execution-column {
        position: absolute;
        pointer-events: none;
        z-index: 1;
        background: rgba(250, 204, 21, 0.35);
        border-bottom: 2px solid rgba(217, 119, 6, 0.95);
    }

    /* Monaco editor (FlowV2 codeEditorMonaco) — breakpoint / execution gutter and line */
    .monaco-editor .margin .flow-monaco-breakpoint-glyph::before {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        margin: 3px auto 0;
        border-radius: 50%;
        background-color: rgba(220, 16, 20, 0.85);
        box-shadow: 0 0 1px 1px #8c2446 inset;
    }

    .monaco-editor .margin .flow-monaco-exec-glyph::before,
    .monaco-editor .margin .flow-monaco-exec-stack-glyph::before {
        content: "▶";
        font-size: 11px;
        line-height: 1;
        display: block;
        margin: 2px auto 0;
        text-align: center;
    }

    .monaco-editor .margin .flow-monaco-exec-glyph::before {
        color: #ca8a04;
    }

    .monaco-editor .margin .flow-monaco-exec-stack-glyph::before {
        color: #16a34a;
    }

    .monaco-editor .view-overlays .flow-monaco-breakpoint-line,
    .monaco-editor .margin-view-overlays .flow-monaco-breakpoint-line {
        background: rgba(220, 16, 20, 0.12);
    }

    .monaco-editor .view-overlays .flow-monaco-exec-line,
    .monaco-editor .margin-view-overlays .flow-monaco-exec-line {
        background-color: rgba(59, 130, 246, 0.18);
    }

    .monaco-editor .view-overlays .flow-monaco-exec-stack-line,
    .monaco-editor .margin-view-overlays .flow-monaco-exec-stack-line {
        background-color: rgba(34, 197, 94, 0.18);
    }

    .monaco-editor .margin-view-overlays .flow-monaco-validation-error::before,
    .monaco-editor .margin-view-overlays .flow-monaco-validation-warning::before,
    .monaco-editor .margin-view-overlays .flow-monaco-validation-info::before {
        display: block;
        width: 14px;
        height: 14px;
        margin: 1px auto 0;
        border-radius: 50%;
        color: white;
        font-size: 11px;
        font-weight: bold;
        line-height: 14px;
        text-align: center;
    }

    .monaco-editor .margin-view-overlays .flow-monaco-validation-error::before {
        content: "!";
        background: #dc2626;
    }

    .monaco-editor .margin-view-overlays .flow-monaco-validation-warning::before {
        content: "!";
        background: #d97706;
    }

    .monaco-editor .margin-view-overlays .flow-monaco-validation-info::before {
        content: "i";
        background: #2563eb;
    }

    /* FlowV2 generic dialog: remove Quasar minimized width cap so resize can grow past initial width. */
    .flowv2-generic-dialog.q-dialog .q-dialog__inner--minimized > div {
        max-width: none !important;
    }

    /*.ace_tooltip {
        background-color: #f5f5f5;
        border: 1px solid gray;
        border-radius: 1px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        color: black;
        padding: 3px 4px;
        position: fixed;
        z-index: 999999;
        box-sizing: border-box;
        cursor: default;
        white-space: pre-wrap;
        word-wrap: break-word;
        line-height: normal;
        font-style: normal;
        font-weight: normal;
        letter-spacing: normal;
        pointer-events: none;
        overflow: auto;
        max-width: min(33em, 66vw);
        overscroll-behavior: contain;
    }*/

    .q-radio__label {
        color: var(--q-grey-8, #202020) !important;
    }

    .sform-checkbox-neutral .q-checkbox__label {
        color: var(--q-grey-8, #202020) !important;
        /* Label text + optional hint icon sit side by side; center the icon with the text. */
        display: inline-flex;
        align-items: center;
    }

    .sform-checkbox-neutral .q-checkbox__label .q-icon,
    .c-Checkbox .q-checkbox__label .q-icon,
    .q-toggle__label .q-icon.mdi-information,
    .form-hint-icon {
        color: var(--v-checkboxGrey-base) !important;
    }

    .q-checkbox__inner {
        width: 16px !important;
        min-width: 16px !important;
        height: 16px !important;
    }

    /* Unchecked outline for QCheckbox and icon-based checkboxes. */
    .q-checkbox__inner--falsy {
        color: var(--v-checkboxGrey-base);
    }

    .q-icon.mdi-checkbox-blank-outline,
    .mdi.mdi-checkbox-blank-outline {
        color: var(--v-checkboxGrey-base) !important;
    }

    /* Icon-as-checkbox in QSelect menus. Quasar sets
       .q-item__section--side > .q-icon { font-size: 24px }, which beat the
       previous single-class 18px rule — match .q-checkbox__inner (16px).
       Avatar side sections stay min-width 56px / pr 16px; shrink them so the
       icon→label gap matches .q-checkbox__label padding-left (7px). */
    .q-item__section--side > .q-icon.mdi-checkbox-blank-outline,
    .q-item__section--side > .q-icon.mdi-checkbox-marked,
    .q-item__section--side > .q-icon.mdi-checkbox-marked-outline,
    .q-item__section--side > .q-icon.mdi-checkbox-intermediate,
    .q-item__section--side > .q-icon.mdi-close-box,
    .q-item__section--side > .q-icon.mdi-minus-box,
    .mdi-checkbox-blank-outline,
    .mdi-checkbox-marked,
    .mdi-checkbox-marked-outline {
        font-size: 16px;
    }

    .q-item__section--side:has(> .q-icon.mdi-checkbox-blank-outline),
    .q-item__section--side:has(> .q-icon.mdi-checkbox-marked),
    .q-item__section--side:has(> .q-icon.mdi-checkbox-marked-outline),
    .q-item__section--side:has(> .q-icon.mdi-checkbox-intermediate),
    .q-item__section--side:has(> .q-icon.mdi-close-box),
    .q-item__section--side:has(> .q-icon.mdi-minus-box) {
        min-width: 0;
        padding-right: 7px;
    }

    /* Beat Quasar .q-menu { max-height: 65vh } (same single-class specificity otherwise).
       Keep below !important so the position engine can still shrink near viewport edges. */
    .q-menu.q-select-max-popup-height {
        max-height: 280px;
    }

    /* Menu / list hover (Vue3): Quasar paints .q-focus-helper with currentcolor
       at low opacity (gray on default text). Paint activeBackground on the host
       instead — an opaque helper covers labels (e.g. Sound File select options).
       .q-btn is excluded from the general rule; only buttons inside a popup
       (.q-menu / BasicPopupMenu host) get activeBackground. List .q-item rows
       (selects, PopupMenuButton) still get it everywhere they appear. */
    body.desktop .q-item.q-hoverable:hover:not(.q-btn),
    body.desktop .q-item.q-manual-focusable--focused:not(.q-btn),
    body.desktop .q-item.q-focusable:focus:not(.q-btn),
    body.desktop .q-menu .q-hoverable:hover:not(.q-btn),
    body.desktop .q-menu .q-manual-focusable--focused:not(.q-btn),
    body.desktop .q-menu .q-focusable:focus:not(.q-btn),
    body.desktop .q-menu .q-btn.q-hoverable:hover,
    body.desktop .q-menu .q-btn.q-manual-focusable--focused,
    body.desktop .q-menu .q-btn.q-focusable:focus,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-hoverable:hover,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-manual-focusable--focused,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-focusable:focus {
        background-color: var(--v-activeBackground-base, #eef0ff);
    }

    body.desktop .q-item.q-hoverable:hover:not(.q-btn) > .q-focus-helper,
    body.desktop .q-item.q-manual-focusable--focused:not(.q-btn) > .q-focus-helper,
    body.desktop .q-item.q-focusable:focus:not(.q-btn) > .q-focus-helper,
    body.desktop .q-menu .q-hoverable:hover:not(.q-btn) > .q-focus-helper,
    body.desktop .q-menu .q-manual-focusable--focused:not(.q-btn) > .q-focus-helper,
    body.desktop .q-menu .q-focusable:focus:not(.q-btn) > .q-focus-helper,
    body.desktop .q-menu .q-btn.q-hoverable:hover > .q-focus-helper,
    body.desktop .q-menu .q-btn.q-manual-focusable--focused > .q-focus-helper,
    body.desktop .q-menu .q-btn.q-focusable:focus > .q-focus-helper,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-hoverable:hover > .q-focus-helper,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-manual-focusable--focused > .q-focus-helper,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-focusable:focus > .q-focus-helper,
    body.desktop .q-item.q-hoverable:hover:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-item.q-manual-focusable--focused:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-item.q-focusable:focus:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-menu .q-hoverable:hover:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-menu .q-manual-focusable--focused:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-menu .q-focusable:focus:not(.q-btn) > .q-focus-helper::before,
    body.desktop .q-menu .q-btn.q-hoverable:hover > .q-focus-helper::before,
    body.desktop .q-menu .q-btn.q-manual-focusable--focused > .q-focus-helper::before,
    body.desktop .q-menu .q-btn.q-focusable:focus > .q-focus-helper::before,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-hoverable:hover > .q-focus-helper::before,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-manual-focusable--focused > .q-focus-helper::before,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-focusable:focus > .q-focus-helper::before,
    body.desktop .q-item.q-hoverable:hover:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-item.q-manual-focusable--focused:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-item.q-focusable:focus:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-menu .q-hoverable:hover:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-menu .q-manual-focusable--focused:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-menu .q-focusable:focus:not(.q-btn) > .q-focus-helper::after,
    body.desktop .q-menu .q-btn.q-hoverable:hover > .q-focus-helper::after,
    body.desktop .q-menu .q-btn.q-manual-focusable--focused > .q-focus-helper::after,
    body.desktop .q-menu .q-btn.q-focusable:focus > .q-focus-helper::after,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-hoverable:hover > .q-focus-helper::after,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-manual-focusable--focused > .q-focus-helper::after,
    body.desktop .c-BasicPopupMenu-menuHost .q-btn.q-focusable:focus > .q-focus-helper::after {
        background: transparent !important;
        opacity: 0 !important;
    }

    /* Tab panels only: avoid reserved messages row forcing q-panel overflow (scrollbar). */
    .c-formTabs .q-field__messages {
        min-height: 0;
    }
    
    .q-field--outlined .q-field__control {
        border-radius: 8px;
    }
    
    /* Quasar leaves outlined controls transparent, so the page background shows
       through. Only some schemaform fields opted in via .sform-input-white. */
    .q-field--outlined:not(.q-field--dark) .q-field__control {
        background-color: white;
    }

    .q-field--outlined .q-field__control:before {
        border-color: var(--v-lightGreyBorder-base);
    }

    /* Quasar hovers outlined fields to solid #000; soften to a primary tint. */
    .q-field--outlined .q-field__control:hover:before {
        border-color: rgb(from var(--v-primary-base) r g b / 0.5);
    }
    
    .q-field--outlined.q-field--highlighted .q-field__control:after {
        border-width: 1px;
    }

    .c-TextAreaWithHeaderBar .q-field--outlined .q-field__control {
        padding-right: 0 !important;
    }

    .c-TextAreaWithHeaderBar .q-field--outlined .q-field__native {
        min-height: 70px;
        padding-right: 12px !important;
    }

    .c-TextAreaWithHeaderBar.q-field--outlined .q-field__append {
        position: absolute;
        top: 8px;
        right: 8px;
        height: auto;
        padding-left: 0 !important;
    }

    .c-SformTextarea.q-field--outlined .q-field__control {
        padding-right: 0 !important;
    }

    .c-SformTextarea.q-field--outlined .q-field__native {
        padding-right: 12px !important;
    }

    .c-SformTextarea.q-field--outlined .q-field__append {
        position: absolute;
        top: 8px;
        right: 8px;
        height: auto;
        padding-left: 0 !important;
    }
        
    .q-badge {
        padding: 4px 6px !important;
    }

    /* Chat message styles for AskAi component */
    .AskAI .chat-messages-container {
        flex: 1;
        overflow-y: auto;
        margin-top: 24px;
        margin-bottom: 16px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        padding: 16px;
    }

    .AskAI .chat-message-wrapper {
        display: flex;
        margin-bottom: 12px;
    }

    .AskAI .chat-message-user {
        justify-content: flex-end;
    }

    .AskAI .chat-message-assistant {
        justify-content: flex-start;
    }

    .AskAI .chat-message-bubble {
        max-width: 80%;
        padding: 8px 12px;
        border-radius: 12px;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
    }

    .AskAI .chat-message-bubble p {
        margin-bottom: unset;
    }

    .AskAI .chat-message-bubble li {
        white-space: normal;
    }

    .AskAI .chat-message-bubble p:last-child {
        display: inline;
    }

    .AskAI .chat-message-user .chat-message-bubble {
        background-color: var(--v-sentmessage-base);
        color: rgba(0,0,0,0.87);
    }

    .AskAI .chat-message-assistant .chat-message-bubble {
        background-color: var(--v-receivedmessage-base);
        color: rgba(0,0,0,0.87);
    }

    .AskAI .InteractionSelection {
        border: 1px solid rgba(0,0,0,0.12);
    }

    .AskAiInput {
        flex: unset;
    }

    .AskAiRadioInput {
        height: 100%;
        align-items: flex-start !important;
    }

    .AskAiRadioInputTitle {
        font-size: 16px;
        align-items: flex-start !important;
    }

    .dialog-right-panel {
        position: fixed !important;
        right: 0 !important;
        bottom: 0 !important;
        top: anchor(--main-header bottom, 0px);
        left: unset !important;
        width: 550px !important;
        max-width: 550px !important;
        margin: 0 !important;
        border-radius: 0 !important;
        transition: none !important;
        max-height: 100% !important;
        height: auto !important;
    }
    
    .dialog-right-panel .q-dialog__inner {
        align-items: stretch !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        position: absolute;
    }

    .dialog-right-panel .q-dialog__inner > div {
        border-radius: 0;
        width: 550px !important;
        max-width: 550px !important;
        min-width: 550px !important;
    }

    .dialog-right-panel .q-card {
        height: 100% !important;
        max-height: none !important;
        width: 100% !important;
    }

    /* Match q-mx-md (16px) on SM status row / Ask AI body. Quasar default is `.q-toolbar { padding: 0 12px }`. */
    .SilentMonitoringPanel > .q-toolbar,
    .AskAI > .q-toolbar {
        padding-left: 16px;
        padding-right: 16px;
    }

    /* Transcript list must not newspaper-column (Quasar .column is flex-wrap: wrap). */
    .SilentMonitoringPanel .SilentMonitoringTranscript,
    .SilentMonitoringPanel .SilentMonitoringTranscript .column {
        flex-wrap: nowrap !important;
    }

    .SilentMonitoringEmailBody {
        max-width: 100%;
        min-width: 0;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .SilentMonitoringEmailBody img {
        max-width: 100%;
        height: auto;
    }

    .SilentMonitoringEmailBody table {
        width: 100%;
        max-width: 100%;
        table-layout: fixed;
    }

    .SilentMonitoringEmailBody pre {
        max-width: 100%;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .c-CircleChart .apexcharts-legend-series {
        align-items: flex-start !important;
    }

    .c-CircleChart .apexcharts-legend-marker {
        top: -2px !important;
    }

    .c-name-TitleBarRightHandControlsLayout > div {
        overflow: hidden !important;
    }

    .c-formHelp .q-banner__avatar,
    .c-FeedbackBanner .q-banner__avatar,
    .c-Notification .q-banner__avatar {
        align-self: center;
    }

    input::-webkit-calendar-picker-indicator,
    input::-webkit-clear-button,
    input::-webkit-inner-spin-button,
    input::-webkit-search-cancel-button {
        padding-bottom: 4px;
    }

    .q-field--labeled.q-field--dense input::-webkit-calendar-picker-indicator,
    .q-field--labeled.q-field--dense input::-webkit-clear-button,
    .q-field--labeled.q-field--dense input::-webkit-inner-spin-button,
    .q-field--labeled.q-field--dense input::-webkit-search-cancel-button {
        padding-bottom: 14px;
    }

    .q-field--dense .q-field__native[type="number"]::-webkit-inner-spin-button,
    .q-field--dense .q-field__native[type="number"]::-webkit-outer-spin-button {
    /* Pull the arrows up to compensate for the asymmetric padding */
        margin-top: -6px; 
        margin-bottom: 5px; 
    }

    .q-card__actions .c-BasicButton .q-btn {
        padding: 0 16px;
    }

    .c-BasicButton.text-button .HasBackground.disabled,
    .c-BasicPopupMenu.text-button .HasBackground.disabled {
        background: rgba(0, 0, 0, .12) !important;
    }

    .c-BasicButton.text-button .TransparentBackground.disabled,
    .c-BasicPopupMenu.text-button .TransparentBackground.disabled {
        background: transparent !important;
    }

    .q-btn.disabled {
        color: rgba(0, 0, 0, .47) !important;
    }

    .q-btn::before {
        box-shadow: none !important;
    }

    /* Progress Circle — Quasar sizes via font-size; clip phantom scrollHeight so widgets don't show fake scrollbars */
    .c-ProgressCircle,
    .c-ProgressCircle .q-circular-progress {
        overflow: hidden;
        max-height: 100%;
        line-height: 1;
    }

    .q-circular-progress {
        display: block !important;
    }

    .gridHeaderButtons .q-btn, .gridHeaderButtons .c-Icon {
        padding: 0 8px;
        color: var(--v-secondaryText-base);
    }

    .gridHeaderButtons {
        display: flex;
        width: 100%;
        flex-shrink: 0;
        overflow: visible;
        align-items: center;
    }

    .gridHeaderButtons > *:not(.q-space) {
        flex-shrink: 0;
    }

    .gridHeaderButtons div:has(.q-field) {
        margin: 0;
    }

    .gridHeaderButtons .q-field {
        margin: 4px;
    }

    .q-card {
        max-width: 100%;
        color: var(--v-primaryText-base);
        background: var(--v-pageBackground-base);
    }

    .q-card--bordered {
        border-color: var(--v-lightGreyBorder-base);
    }

    .q-separator {
        background-color: var(--v-lightGreyBorder-base);
    }

    .form-html-editor-body {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
    }

    .form-html-editor-body > div {
        display: flex;
        flex: 1 1 auto;
    }

    .form-html-editor-prose {
        flex: 1 1 auto;
        width: 100%;
        outline: none;
        cursor: text;
    }

    .quick-search-input {
        min-height: 32px;
        height: auto;
        flex-grow: 0;
        flex-shrink: 0;
        min-width: 280px;
        overflow: visible;
    }

    /* Quick Search (grid headers + CardBrowser) stays at 32px. */
    .quick-search-input.q-field--dense .q-field__control,
    .quick-search-input.q-field--dense .q-field__marginal {
        height: 32px;
        min-height: 32px;
    }

    .quick-search-input input {
        padding-bottom: 0;
    }

    .quick-search-input .q-field__prepend,
    .quick-search-input .q-field__append {
        height: 32px;
    }

    /* Icon, inactive underline, placeholder, and typed text use secondary text. */
    .quick-search-input .q-field__marginal,
    .quick-search-input .q-field__native,
    .quick-search-input .q-field__input {
        color: var(--v-secondaryText-base);
    }

    .quick-search-input .q-field__native::placeholder,
    .quick-search-input .q-field__input::placeholder {
        color: var(--v-secondaryText-base);
        opacity: 1;
    }

    .quick-search-input.q-field--standard:not(.q-field--highlighted) .q-field__control:before,
    .quick-search-input.q-field--standard:not(.q-field--highlighted) .q-field__control:hover:before {
        border-bottom-color: var(--v-secondaryText-base);
    }

    .history-panel-width {
        min-width: 750px;
        max-width: 750px;
    }

    .report-expansion-item .q-expansion-item__content {
        padding: 8px 24px 16px;
    }

    .report-expansion-item .q-card__section--vert {
        padding: 0;
    }

    .c-ToolPanel_1,
    .c-ToolPanel_1.q-card,
    .c-ToolPanel_1 .q-card {
        background-color: #fff;
        box-shadow: none;
    }

    .c-ToolPanel_1 {
        border-radius: 8px;
        overflow: hidden;
    }

    .c-ToolPanel_1 pre {
        background-color: #fff;
    }

    .c-ToolPanel_1 .q-expansion-item__toggle-icon,
    .report-expansion-item .q-expansion-item__toggle-icon {
        color: var(--v-secondaryText-base);
    }

    .c-ToolPanel_1 .q-expansion-item > .q-expansion-item__container > .q-item:hover,
    .report-expansion-item > .q-expansion-item__container > .q-item:hover {
        background-color: var(--v-gridHeader-base);
    }

    .c-ToolPanel_1 .q-expansion-item > .q-expansion-item__container > .q-item > .q-focus-helper,
    .report-expansion-item > .q-expansion-item__container > .q-item > .q-focus-helper {
        display: none;
    }

    .q-item.filter-expansion-header--selected,
    .q-item.report-filters-header {
        background-color: var(--v-gridHeader-base);
    }

    .q-toggle.disabled .q-toggle__inner {
        opacity: 0.5;
    }

    /* Quasar .q-toggle__inner uses font-size:40px (line-height ~60px) in a shorter box,
       and dense hover scales thumb:before to 1.5×. Both expand overflow:auto
       HorizontalLayout rows into a tiny scrollbar (UserMenu > Debug legacy switch).
       Collapse the line box; replace the scaled ::before with box-shadow (no scroll
       growth). Pad dense toggles so overflow:auto ancestors don’t clip the round ring
       (overflow:hidden on the toggle squared it). */
    .q-toggle__inner {
        line-height: 0;
    }
    .q-toggle--dense {
        /* >5px so the dense hover ring isn’t flush with the box (reads as clipped). */
        padding: 10px;
    }
    body.desktop .q-toggle:not(.disabled) .q-toggle__thumb:before {
        transform: none !important;
        opacity: 0 !important;
    }
    body.desktop .q-toggle:not(.disabled):hover .q-toggle__thumb,
    body.desktop .q-toggle:not(.disabled):focus .q-toggle__thumb {
        /* Thumb box is square; radius so the ring is circular (Quasar rounds :after only). */
        border-radius: 50%;
        /* Match Quasar dense scale ~1.5 (≈5px ring) / normal scale ~2 (≈10px ring). */
        box-shadow: 0 0 0 5px color-mix(in srgb, currentColor 12%, transparent);
    }
    body.desktop .q-toggle:not(.q-toggle--dense):not(.disabled):hover .q-toggle__thumb,
    body.desktop .q-toggle:not(.q-toggle--dense):not(.disabled):focus .q-toggle__thumb {
        box-shadow: 0 0 0 10px color-mix(in srgb, currentColor 12%, transparent);
    }

    .c-AdvancedReports-queryError {
        position: fixed;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 6000;
        max-width: min(600px, calc(100vw - 48px));
        box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),
                    0 6px 10px 0 rgba(0,0,0,.14),
                    0 1px 18px 0 rgba(0,0,0,.12);
    }

    /* Edge-to-edge hover (CCDEV-17617); docs can still set PopupMenuBodyPadding inline. */
    .PopupMenuButtons {
        padding: 0;
    }

    .PopupMenuButtons .q-item {
        padding: 16px;
        margin: 0;
        font-weight: 500;
        color: var(--q-secondary);
    }

    /* PopupMenuButton ControlData.Condensed — tighter vertical padding. */
    .PopupMenuButtons.PopupMenuButtons--condensed .q-item {
        padding: 4px 16px;
    }

    .PopupMenuButtons .q-item.disabled {
        color: rgba(0, 0, 0, .47) !important;
    }
</style>

<style lang="scss">
/*
 * AG Grid active column-filter indicator (.ag-filter-active):
 *   - 6px corner "dot" → --ag-icon-button-active-indicator-color
 *   - chip / button fill → --ag-icon-button-active-background-color
 *   - filter icon → --ag-icon-button-active-color
 * Values from quasar-variables.sass ($primary / $activeBackground).
 */
.ag-theme-alpine {
    --ag-alpine-active-color: #{$primary};
    --ag-icon-button-active-color: #{$primary};
    --ag-icon-button-active-indicator-color: #{$primary};
    --ag-icon-button-active-background-color: #{$activeBackground};
}

.ag-theme-alpine .ag-filter-active {
    background-color: $activeBackground;
    background-image: linear-gradient($activeBackground, $activeBackground);
    outline-color: $activeBackground;
    color: $primary;
}

.ag-theme-alpine .ag-filter-active:after {
    background-color: $primary;
}

.ag-theme-alpine .ag-filter-active .ag-icon-filter,
.ag-theme-alpine .ag-header-cell-filtered .ag-icon-filter,
.ag-theme-alpine .ag-header-cell-filtered .ag-header-cell-filter-button .ag-icon {
    color: $primary;
}

.ag-theme-alpine .ag-header-cell-filtered .ag-header-cell-filter-button {
    background-color: $activeBackground;
    border-radius: 8px;
    color: $primary;
}

/* Dense fields ship at 40px, which crowds the label against the value. The label top and
   native padding below are re-derived from 47px; changing this height means redoing both.
   Edit $dense-expanded-exclude to keep surfaces on Quasar dense defaults. */
$dense-expanded-exclude: '.gridHeaderButtons *, .quick-search-input, .designer-base *, .designer-container *, .control-designer-properties-panel *, .property-grid *';

/* Fixed-height dense inputs. Skip textarea / auto-height (QSelect) — those use height:auto. */
.q-field--dense:not(.q-textarea):not(.q-field--auto-height):not(:is(#{$dense-expanded-exclude})) {
    .q-field__control,
    .q-field__marginal {
        height: 47px;
    }
}

/* Schema-form Controls beside a field (e.g. EditChat color swatches): center on the dense
   control box. Without this, flex stretch top-aligns a shorter ControlContainer against the
   full q-field (control + bottom slots) so the square sits high relative to the input.
   min-height (not height) so taller Controls / side-by-side fields are not clipped. */
.sform-fieldset-group-item:has(> .q-field) > .sform-fieldset-group-controls {
    display: flex;
    align-items: center;
    min-height: 47px;
    flex-shrink: 0;
}

/* QSelect / auto-height: keep height:auto (fixed height + padded native pins value to the bottom). */
.q-field--dense.q-field--auto-height:not(:is(#{$dense-expanded-exclude})) {
    .q-field__control {
        height: auto;
        min-height: 47px;
    }

    .q-field__marginal {
        height: 47px;
    }

    /* Unlabeled only — labeled selects keep Quasar's 24px native so the value can center. */
    &:not(.q-field--labeled) .q-field__native {
        min-height: 47px;
    }

    &.q-field--labeled {
        .q-field__control-container {
            padding-top: 15px;
        }

        .q-field__shadow {
            top: 15px;
        }

        .q-field__native {
            min-height: 24px;
        }
    }
}

/* Resting label: (47 - 17.5px line box) / 2 keeps it centred in the taller control. */
.q-field--dense:not(.q-textarea):not(:is(#{$dense-expanded-exclude})) .q-field__label {
    top: 14px;
}

/* 18 + 24px line-height + 5 fills the 47px control. Skip textareas / auto-height. */
.q-field--labeled.q-field--dense:not(.q-field--auto-height):not(.q-textarea):not(:is(#{$dense-expanded-exclude})) {
    .q-field__native,
    .q-field__prefix,
    .q-field__suffix {
        padding-top: 18px;
        padding-bottom: 5px;
    }
}

/* Floated label lands at 14 - 40% of 17.5px = 7px from the top of the control. */
.q-field--dense.q-field--float:not(:is(#{$dense-expanded-exclude})) .q-field__label {
    transform: translateY(-40%) scale(.75);
}

/* Date/time/autofilled inputs always float; Quasar's :has() out-specifies the rule above. */
.q-field--dense:not(:is(#{$dense-expanded-exclude})) .q-field__label:has(+ :is(.q-field__native, .q-field__input):is(
    :-webkit-autofill,
    [type="color"],
    [type="date"],
    [type="datetime-local"],
    [type="month"],
    [type="time"],
    [type="week"]
)) {
    transform: translateY(-40%) scale(.75);
}
</style>
